import { assign, entryId } from "../../helper.js";
import { isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/memo.entity.js
var createMemo = () => ({
	id: "",
	value: "",
	ui: {
		x: 200,
		y: 100,
		zIndex: 2,
		width: 116,
		height: 100,
		color: ""
	}
});
function createAndMergeMemoEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createMemo();
		const assignString = assign(isString, target, value);
		const uiAssignNumber = assign(isNumber, target.ui, value.ui);
		const uiAssignString = assign(isString, target.ui, value.ui);
		target.id = entryId(key, value);
		assignString("value");
		uiAssignString("color");
		uiAssignNumber("x");
		uiAssignNumber("y");
		uiAssignNumber("zIndex");
		uiAssignNumber("width");
		uiAssignNumber("height");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeMemoEntities, createMemo };
